<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <v-card-title class="pa-7">
        Přehled zpráv a upozornění
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          height="40px"
          min-width="130px"
          depressed
          :to="{ name: 'messages.add' }"
        >
          Nová zpráva
        </v-btn>
      </v-card-title>
      <v-card-text>
        <MessagesFilters @filter="setFiltersAction" />

        <v-data-table
          :headers="messageHeadersByRole"
          :items="message.items"
          :options.sync="message.options"
          :server-items-length="message.serverItemsLength"
          :loading="message.loading"
          item-key="id"
          class="elevation-0"
        >
          <template v-slot:item.id="{ item }">
            <router-link
              :to="{
                name: 'messages.detail',
                params: {
                  id: item.id,
                },
              }"
            >
              {{ item.id }}
            </router-link>
          </template>
          <template v-slot:item.content="{ item }">
            <div class="cut-text-dot-100">
              {{ item.content }}
            </div>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <DateTime :datetime="item.createdAt" :single-line="false" />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn-toggle color="primary" dense group>
              <v-btn
                :to="{ name: 'messages.edit', params: { id: item.id } }"
                color="blue-grey"
                text
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn color="blue-grey" text @click="removeMessage(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MessagesFilters from '@/components/filters/MessagesFilters.vue'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'

export default {
  name: 'Messages',
  components: {
    DateTime,
    MessagesFilters,
  },
  mixins: [setFilters],
  data() {
    return {
      message: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            width: '150px',
          },
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Vytvořil',
            value: 'createdBy',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Komu',
            value: 'whom.text',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Obsah',
            value: 'content',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      messageFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    messageHeadersByRole() {
      return this.message.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'message.options': {
      handler() {
        this.loadMessages()
      },
    },
    '$route.query': {
      handler() {
        this.loadMessages()
      },
    },
  },
  methods: {
    ...mapActions({
      searchMessages: 'message/searchMessages',
      deleteMessage: 'message/deleteMessage',
    }),
    loadMessages() {
      this.message.loading = true
      let filterParams = this.$route.query
      filterParams['types'] = ['CLOSABLE']
      filterParams['origin'] = false
      const searchParams = {
        filterParams: filterParams,
        options: this.message.options,
      }
      this.searchMessages(searchParams)
        .then((response) => {
          this.messageFooter.totalElements = response.data.totalElements
          this.message.items = response.data.items
          this.message.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.message.loading = false
        })
    },
    removeMessage(id) {
      this.$confirm('', {
        title: 'Smazat zprávu?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.message.loading = true
          this.deleteMessage(id)
            .then(() => {
              this.loadMessages()
            })
            .finally(() => {
              this.message.loading = false
            })
        }
      })
    },
    setFiltersAction(filters) {
      this.message.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
